import React from "react";
import { Field } from "redux-form";

import { customInput } from "../../../../common/custom-input";

import styles from "../../JobStyle.module.css";

const ClientContractorSection = ({ loading }) => {
  return (
    <div className="my-2">
      <div className="container-fluid px-0">
        {/* Row 1: Client Company, ABN, Client Address */}
        <div className="row mb-2">
          <div className="col-12 col-md-3 col-lg-3 col-xl-3">
            <div className={styles.Label}>Client Company</div>
            <Field name="client_name" className={styles.TextField} component={customInput} disabled={loading} />
          </div>
          <div className="col-12 col-md-3 col-lg-3 col-xl-3">
            <div className={styles.Label}>ABN</div>
            <Field name="client_abn" className={styles.TextField} component={customInput} disabled={loading} />
          </div>
          <div className="col-12 col-md-6 col-lg-6 col-xl-6">
            <div className={styles.Label}>Client Address</div>
            <Field name="client_address" className={styles.TextField} component={customInput} disabled={loading} />
          </div>
        </div>
        {/* Row 2: Client Contact, Client Email, Client Phone, Client Position */}
        <div className="row">
          <div className="col-12 col-md-3 col-lg-3 col-xl-3">
            <div className={styles.Label}>Client Rep</div>
            <Field name="client_contact_person_name" className={styles.TextField} component={customInput} disabled={loading} />
          </div>
          <div className="col-12 col-md-3 col-lg-3 col-xl-3">
            <div className={styles.Label}>Client Email</div>
            <Field name="client_contact_email" className={styles.TextField} component={customInput} disabled={loading} />
          </div>
          <div className="col-12 col-md-3 col-lg-3 col-xl-3">
            <div className={styles.Label}>Client Phone</div>
            <Field name="client_contact_phone" className={styles.TextField} component={customInput} disabled={loading} />
          </div>
          <div className="col-12 col-md-3 col-lg-3 col-xl-3">
            <div className={styles.Label}>Client Position</div>
            <Field name="client_contact_role" className={styles.TextField} component={customInput} disabled={loading} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientContractorSection;
